const text = (value) => String(value || "").trim();

export const isDecoratorPo = (po = {}) => {
  const info = po.supplierInfo || {};
  return Boolean(po.decoratorId || po.DecoratorId || info.decoratorId || info.DecoratorId ||
    text(po.partyType || po.poPartyType || info.poPartyType).toLowerCase() === "decorator");
};

export const resolvePoRoutingDisplay = (po = {}) => {
  const info = po.supplierInfo || {};
  const destination = po.shippingDestination || info.shippingDestination || po.ShipTo || info.ShipTo || info.shipTo || po.shipTo || {};
  const explicitType = text(destination.type || destination.Type).toLowerCase();
  const decoratorId = destination.DecoratorId || destination.decoratorId;
  const decoratorName = text(destination.decoratorName || destination.DecoratorName ||
    destination.Decorator?.Name || destination.Decorator?.name || info.destinationDecoratorName);
  // The persisted supplierInfo route is authoritative. The top-level value is a
  // compatibility fallback for older API responses.
  const routeSummary = text(info.routeSummary || po.routeSummary) || (
    text(info.shippingRole).toLowerCase() === "decorator"
      ? "Decorator → Client"
      : text(info.shippingRole).toLowerCase() === "goods_supplier"
        ? "Supplier → Decorator"
        : ""
  );
  const decoratorToClient = /^decorator\s*(?:→|->|to)\s*client$/i.test(routeSummary);
  const decoratorDestination = explicitType === "decorator" || Boolean(decoratorId) || Boolean(decoratorName) || /supplier\s*→\s*decorator/i.test(routeSummary);
  const partyIsDecorator = isDecoratorPo(po);
  const destinationName = decoratorDestination
    ? (decoratorName || text(destination.name) || text(destination.Address?.addressName) || text(info.destinationName) || "Decorator")
    : (text(destination.name || destination.addressName || destination.Address?.addressName || info.destinationName) || (explicitType === "client" || text(destination.shipTo || destination.ShipTo).toLowerCase() === "client" ? "Client" : "Destination not specified"));

  if (decoratorToClient) {
    return {
      partyType: "decorator",
      destinationType: "client",
      destinationName: "Client",
      primaryLabel: "Ships to: Client",
      secondaryLabel: `Route: ${routeSummary}`,
    };
  }

  if (partyIsDecorator) {
    return {
      partyType: "decorator",
      destinationType: "decorator",
      destinationName,
      primaryLabel: "Decorator PO",
      secondaryLabel: text(info.receivesGoodsFrom || info.sourceSupplierName) ? `Receives goods from: ${text(info.receivesGoodsFrom || info.sourceSupplierName)}` : "Decorator PO",
    };
  }
  return {
    partyType: "supplier",
    destinationType: decoratorDestination ? "decorator" : (explicitType || "unknown"),
    destinationName,
    primaryLabel: `Ships to: ${destinationName}`,
    secondaryLabel: `Route: ${routeSummary || `Supplier → ${decoratorDestination ? "Decorator" : (explicitType === "client" ? "Client" : "Destination")}`}`,
  };
};
